import { render, staticRenderFns } from "./InvestorMerchantContractPage.vue?vue&type=template&id=652154a8&scoped=true"
import script from "./InvestorMerchantContractPage.vue?vue&type=script&lang=js"
export * from "./InvestorMerchantContractPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652154a8",
  null
  
)

export default component.exports